import { render, staticRenderFns } from "./CodeSnippet.vue?vue&type=template&id=1bac6e35&"
import script from "./CodeSnippet.vue?vue&type=script&lang=js&"
export * from "./CodeSnippet.vue?vue&type=script&lang=js&"
import style0 from "./CodeSnippet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports